export enum DataDomainTypes {
    compound = 'COMPOUND',
    target = 'TARGET',
    molecularBiomarker = 'DRIVER'
}

export enum ResearchTypeMap {
    'CLINICAL' = 'Clinical',
    'PRECLINICAL' = 'Preclinical',
    'IN_SILICO' = 'In silico'
}

export enum RelationTypeMap {
    'POSITIVE' = 'positive',
    'NEUTRAL' = 'neutral',
    'NEGATIVE' = 'negative'
}
